module.exports = __webpack_public_path__ + "static/media/BusinessWire.58f9bc2d.svg";